<template>
    <div class="container-fluid px-4 px-xl-5 mt-3 mt-xl-0 mb-5">
        <!-- Beautified Fixed Button -->
        <a href="/sixnes-erwtiseis-faq" target="_blank" class="fixed-button-faq" title="Συχνές Ερωτήσεις (FAQ)">
            <span class="button-text"><i class="icofont-info"></i></span>
        </a>
        <button class="fixed-button" data-bs-toggle="modal" data-bs-target="#mapModal">
            <span class="button-text"><i class="icofont-google-map"></i>Προβολή χάρτη</span>
        </button>

        <!-- Header Section -->
        <div class="header-section mb-4 mb-xl-4">
            <div class="d-flex justify-content-center">
                <div class="d-flex align-items-center">
                    <!-- <h1 class="fw-bold mb-0 homeNumberOffers">200<sup style="color: #175576;text-shadow: none;">+</sup></h1> -->
                    <div>
                        <h1 class="mb-0 homeOfferText">
                            <span style="text-shadow: 1px 0px #175576;font-weight:bold;">
                                <span class="fs-1" style="color: #54B7F3;text-shadow: 2px 0px #54B7F3;">ΣΤΗΡΙΞΕ</span>
                                <br>ΤΙΣ ΤΟΠΙΚΕΣ <br>ΕΠΙΧΕΙΡΗΣΕΙΣ
                            </span>
                        </h1>
                    </div>
                    <div>
                        <img src="../assets/images/and.png" alt="" width="120">
                    </div>
                    <div style="margin-left: -15px;">
                        <h1 class="mb-0 fw-bold fs-3 text-start homeOffersubText">
                            <span style="color: #175576;">
                                Επωφελήσου από τις<br><span class="fs-2">Καλύτερες<br> Προσφορές</span>
                            </span>
                        </h1>
                    </div>

                </div>
                <!-- <div>
                    <h1 class="fw-bold mb-0 homeOfferText">ΠΡΟΣΦΟΡΕΣ</h1>
                    <h2 class="mb-0 color-700 homeOffersubText">ΜΟΝΟ ΓΙΑ ΕΣΕΝΑ!</h2>
                </div> -->
            </div>
            <!-- <p class="fs-5 color-600 mt-2">
                Δες όλες τις προσφορές των καταστημάτων<br />
                μας και διάλεξε αυτές που εσύ θέλεις!
            </p> -->

        </div>

        <div class="row d-flex align-items-end text-end mb-4 justify-content-center-mobile">
            <div class="d-flex gap-xl-3 gap-1 justify-content-center-mobile col-12 col-xl-4 w-auto px-1">
                <button class="mapMobBtn" data-bs-toggle="modal" data-bs-target="#mapModal">
                    <span class="button-text"><i class="icofont-google-map"></i>&nbsp;Προβολή χάρτη</span>
                </button>
                <button @click="randomizeData" :class="['btn-sorting', activeSort === 'random' ? 'active' : '']">
                    <i class="icofont-random"></i>&nbsp;
                    <span>Τυχαία προβολή</span>
                </button>
                <button @click="sortAlphabetically"
                    :class="['btn-sorting', activeSort === 'alphabetical' ? 'active' : '']">
                    <i class="icofont-text-height"></i>&nbsp;
                    <span>Αλφαβητικά</span>
                </button>
                <div class="shortcutBtnDiv">
                    <div class="shortcutBtn" data-bs-toggle="modal" data-bs-target="#shortcutModal">
                        <i class="icofont-tack-pin fs-3"></i>
                    </div>
                    <div class="modal fade" id="shortcutModal" tabindex="-1" aria-labelledby="shortcutModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header border-0 pb-0">
                                    <h5 class="modal-title text-center fs-6 fw-bold" id="shortcutModalLabel" style="color:#175576">ΣΥΝΤΟΜΕΥΣΗ ΤΗΣ ΕΦΑΡΜΟΓΗΣ ΣΤΗΝ ΑΡΧΙΚΗ ΟΘΟΝΗ ΤΟΥ ΚΙΝΗΤΟΥ ΣΟΥ!</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body px-1 text-start">
                                    <div>
                                        <div class="d-flex justify-content-between align-items-center gap-3">
                                            <div class="w-100">
                                                <hr>
                                            </div>
                                            <div>
                                                <img src="../assets/images/android.png" alt="" width="42">
                                            </div>
                                            <div class="w-100">
                                                <hr>
                                            </div>
                                        </div>
                                        <div style="font-size: 14px;">
                                            <div class="text-center">
                                                <span class="fw-bold" style="color:#175576">Για χρήστες Android</span><br>
                                                Απλώς πατήστε το παρακάτω κουμπί και προσθέστε τη σελίδα στην αρχική σας
                                                οθόνη.<br><br>
                                                <button class="shortcutBtnModal" @click="addToHomeScreen">
                                                    <i class="icofont-ui-home"></i>&nbsp;<span>Προσθήκη στην Αρχική</span>
                                                </button>
                                            </div>
                                            <br>
                                            <div class="d-flex justify-content-between align-items-center gap-3">
                                                <div class="w-100">
                                                    <hr>
                                                </div>
                                                <div>
                                                    <img src="../assets/images/apple.png" alt="" width="42">
                                                </div>
                                                <div class="w-100">
                                                    <hr>
                                                </div>
                                            </div>
                                            <div class="text-center">
                                                <span class="fw-bold" style="color:#175576">Για χρήστες iPhone (iOS)</span><br>
                                            </div>
                                            <div class="mt-3 d-flex">
                                                <div class="gap-2 d-flex flex-column align-items-center text-center">
                                                    <span style="color: #181818;padding-bottom: 5px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;border-bottom: 3px solid #54B7F3;font-weight: bold;">01</span>Πατήστε
                                                    το εικονίδιο "Κοινοποίηση" (το τετράγωνο με το βέλος προς τα πάνω) στο
                                                    κάτω μέρος του Safari. <br>
                                                </div>
                                                <div class="gap-2 d-flex flex-column align-items-center text-center">
                                                    <span style="color: #181818;padding-bottom: 5px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;border-bottom: 3px solid #54B7F3;font-weight: bold;">02</span>Επιλέξτε
                                                    "Προσθήκη στην αρχική οθόνη" από το μενού που εμφανίζεται.<br>
                                                </div>
                                                <div class="gap-2 d-flex flex-column align-items-center text-center">
                                                    <span style="color: #181818;padding-bottom: 5px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;border-bottom: 3px solid #54B7F3;font-weight: bold;">03</span>Πατήστε
                                                    "Προσθήκη", και η συντόμευση θα εμφανιστεί στην αρχική σας
                                                    οθόνη!<br><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                        Κλείσιμο
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-12 mt-xl-0 mt-3 col-xl-4 d-flex align-items-end justify-content-center gap-3 pe-0">
                <div class="col justify-content-center-mobile">
                    <h3 class="color-700 fs-3 mb-0 text-nowrap" style="letter-spacing:2px;"><span
                            style="color: #175576;font-size:3rem">•</span> Κατηγορίες</h3>
                </div>
                <div class="col categoryNameSection">
                    <!-- <hr> -->
                </div>
            </div>

            <div class="col-10 mob-column col-xl-4 d-flex searchSection justify-content-end">
                <div class="w-75 w-sm-100">
                    <form class="ms-auto w-100 w-smScrn-100 mt-3 mt-xl-0 searchDiv" @submit.prevent>
                        <input ref="searchInput" v-model="searchQuery" @keyup="search" @click="search"
                            class="form-control search-input" type="search" placeholder="Αναζήτηση Επιχείρησης..."
                            aria-label="Search">
                        <img v-if="!searchQuery" class="search-icon" width="35" src="../assets/images/search-icon.png"
                            alt="Search Icon">
                        <!-- Search Results Section -->
                        <div ref="searchResults" v-if="searchResults.length > 0"
                            class="search-results position-absolute w-100">
                            <div class="card" v-for="business in searchResults" :key="business.id">
                                <!-- Make the entire card clickable by wrapping it in RouterLink -->
                                <RouterLink :to="getLink(business)" class="card-link">
                                    <div class="card-body">
                                        <span class="card-title fs-6">{{ business.brandname }}</span>
                                    </div>
                                </RouterLink>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Categories Section -->
        <div class="grid-container" :style="gridStyles">
            <div v-for="category in categories" :key="category.id" :class="[
                `grid-item item${category['gridItem']}`,
                { grayscale: category.business_counts === 0 }
            ]" :style="category.src ? {} : { backgroundColor: category.bg_color }">
                <div class="category-box" @click="goToCategory(category.id, category.slug)">
                    <img class="homeBanners" :src="category.src" :alt="category.title" v-if="category.src" />
                    <span :class="[`category-label text-uppercase ${category['category_label']}`]">
                        {{ category.title }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Bootstrap Modal -->
        <div class="modal fade" id="mapModal" tabindex="-1" aria-labelledby="mapModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="mapModalLabel">Χάρτης</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <LeafletMap v-if="isMapVisible" ref="leafletMap" :locations="locations" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            Κλείσιμο
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="px-xl-5 px-3 pb-3 mb-5 mb-xl-0 profSection">
        <div class="d-flex gap-3 gap-xl-0 flex-column-mobile align-items-center justify-content-around">
            <div class="mt-xl-0 mt-4">
                <h3 class="fs-1 mb-3 fw-bold" style="color: #175576;">
                    <i>ΕΙΣΑΙ<span
                            style="color:#2D9CE0;position: relative;top: -5px;right: -5px;">_</span><br>ΕΠΑΓΓΕΛΜΑΤΙΑΣ;</i>
                </h3>
                <span class="fs-4">
                    Ανάδειξε και προώθησε την<br>
                    επιχείρησή σου σήμερα!<br>
                </span>
                <button class="mt-3 myBtnHome btn">
                    <a class="text-white" href="/merchant">Καταχώρησέ την εδώ</a>
                </button>
            </div>
            <div class="text-center">
                <img src="../assets/images/home/banner-man.png" alt="" class="sectionBnrImg">
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
import ApexCharts from 'apexcharts';
import { useHead } from '@vueuse/head';
import { useToast } from 'vue-toastification';
import { getBusinessCategories } from '@/services/category';
import LeafletMap from '@/components/LeaftletMap.vue';
import { getAllBusinessPartners } from '@/services/business-partners';
import { searchBusinessPartner } from '@/services/business-partners';
import { getAppInfo } from '@/services/appInfo';

export default {
    components: { LeafletMap },
    name: 'Home',
    data() {
        return {
            categories: [], // Store categories from API
            locations: [],
            isMapVisible: false,
            activeSort: 'random',
            searchQuery: '', // Bound to the search input
            searchResults: [] // Array to hold search results
        };
    },
    methods: {
        goToCategory(id, slug) {
            this.$router.push(`/category/${id}/${slug}`);
        },
        initializeMapOnModalShow() {
            const modal = document.getElementById('mapModal');
            modal.addEventListener('shown.bs.modal', () => {
                this.isMapVisible = true; // Render the LeafletMap component
                this.$nextTick(() => {
                    if (this.$refs.leafletMap) {
                        this.$refs.leafletMap.invalidateSize();
                    }
                });
            });

            modal.addEventListener('hidden.bs.modal', () => {
                this.isMapVisible = false; // Unmount the LeafletMap component
            });
        },
        randomizeData() {
            if (Array.isArray(this.categories)) {
                this.categories = this.categories.sort(() => Math.random() - 0.5);
                this.activeSort = 'random';
            } else {
                console.warn('Categories data is not an array.');
            }
        },
        sortAlphabetically() {
            if (Array.isArray(this.categories)) {
                this.categories = this.categories.sort((a, b) =>
                    a.title.localeCompare(b.title)
                );
                this.activeSort = 'alphabetical';
            } else {
                console.warn('Categories data is not an array.');
            }
        },
        async addToHomeScreen() {
            if (this.deferredPrompt) {
                this.deferredPrompt.prompt();
                const { outcome } = await this.deferredPrompt.userChoice;
                if (outcome === "accepted") {
                    console.log("User added the app to the home screen");
                } else {
                    console.log("User dismissed the installation prompt");
                }
                this.deferredPrompt = null;
            } else {
                alert("Your browser does not support home screen shortcuts");
            }
        },
        async fetchCategories() {
            try {
                const allBusinessPartners = await getAllBusinessPartners();
                let locations = [];
                for (let i = 0; i < allBusinessPartners.data.data.length; i++) {
                    if (allBusinessPartners.data.data[i].Lat && allBusinessPartners.data.data[i].Lon) {
locations.push({
  title: allBusinessPartners.data.data[i].brandname,
  lat: allBusinessPartners.data.data[i].Lat,
  lon: allBusinessPartners.data.data[i].Lon,
  address: allBusinessPartners.data.data[i].address || "Διεύθυνση μη διαθέσιμη" // <-- αυτό είναι ΟΚ τώρα
});
                    }
                }
                this.locations = locations;
                const response = await getBusinessCategories();
                if (response.data.success) {
                    this.categories = response.data.data; // Correctly access the categories array
                } else {
                    console.error('Failed to fetch categories:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        },
        async fetchData() {
            try {
                // Replace with your actual API URL
                const response = await getAppInfo();
                this.apiData = response.data.success ? response.data.data : false;
            } catch (error) {
                this.error = error.message || 'Error fetching data';
                console.error(this.error);
            }
        },
        async search() {
            let self = this;
            setTimeout(async () => {
                // Ensure the search query is at least 2 characters long
                if (self.searchQuery.length < 2) {
                    self.searchResults = [];
                    return;
                }
                try {
                    // Call the search API with the current search query
                    const response = await searchBusinessPartner({ search: self.searchQuery });
                    self.searchResults = response.data.success ? response.data.data : []; // Assuming the response contains an array of businesses
                } catch (error) {
                    console.error('Error searching:', error);
                }
            }, 500);
        },
        resetSearchResults() {
            // Clear search results and search query
            this.searchResults = [];
            this.searchQuery = '';
        },
        getLink(business) {

            
            if (business.business_category_id && Array.isArray(business.business_category_id)) {
                return '/profile/' + business.business_category_id[0] + '/' + business.id;
            }
            if (business.business_category_id) {
                return '/profile/' + business.business_category_id + '/' + business.id;
            } else {
                return '#';
            }
        },
        handleClickOutside(event) {
            const searchInput = this.$refs.searchInput;
            const searchResults = this.$refs.searchResults;

            if (
                searchInput && !searchInput.contains(event.target) &&
                searchResults && !searchResults.contains(event.target)
            ) {
                this.resetSearchResults();
            }
        }
    },
    computed: {
        gridStyles() {
            return {
                gridAutoRows: this.activeSort === 'alphabetical' ? '150px' : '150px',
                gridTemplateColumns: this.activeSort === 'alphabetical' ? 'repeat(5, 1fr)' : 'repeat(4, 1fr)',
            };
        },
    },

    mounted() {
        this.fetchData();
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.deferredPrompt = e;
        });
        useHead({
            title: 'Αρχική | My City Market',
            meta: [
                { name: 'description', content: 'Αρχική' },
                { property: 'og:title', content: 'Αρχική' },
                { property: 'og:description', content: 'Αρχική' }
            ]
        });

        // Fetch categories when the component is mounted
        this.fetchCategories();
        this.initializeMapOnModalShow();

        // Check if the modal has already been shown
        if (!localStorage.getItem("modalShown") && window.innerWidth < 768) {
            setTimeout(() => {
                let modalElement = document.getElementById("shortcutModal");
                if (modalElement) {
                    let modal = new bootstrap.Modal(modalElement);
                    modal.show();
                    
                    // Store in localStorage so it won't show again
                    localStorage.setItem("modalShown", "true");
                }
            }, 500); // Delay to ensure Bootstrap loads properly
        }
    }
};
</script>

<style scoped>
.btn-sorting.active {
    background: #175576;
    color: #ffffff !important;
}

.btn-sorting {
    background: #ffffff;
    border: 1px solid #175576 !important;
    color: #175576 !important;
    padding: 1px 8px;
    border-radius: 99px;
}

.btn-sorting:hover {
    background: #8FBDE9;
    color: #ffffff !important;
    transition: .5s;
    border: 1px solid #8FBDE9 !important;
}

.fixed-button-faq{
    position: fixed;
    top: 55%;
    right: 0;
    background-color: #175576;
    color: #fff;
    border: none;
    border-radius: 10px 0px 0px 10px;
    width: 32px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 1000;
}

.fixed-button-faq:hover {
  background-color: #8FBDE9;
  color: white;
}

.fixed-button {
    position: fixed;
    top: 75%;
    right: 0;
    transform: translateY(-50%);
    background-color: #175576;
    color: #fff;
    border: none;
    border-radius: 10px 0px 0px 10px;
    width: 32px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 1000;
    /* Ensures the button appears above other elements */
}

.fixed-button:hover {
    background-color: #8FBDE9;
}

.icofont-eye {
    font-size: 1.5rem;
    margin-bottom: 5px;
    writing-mode: vertical-rl;
    /* Makes text vertical */
    transform: rotate(180deg);
    /* Flips text to read correctly */
}

.fixed-button .button-text {
    writing-mode: vertical-rl;
    /* Makes text vertical */
    transform: rotate(180deg);
    /* Flips text to read correctly */
    font-size: 1rem;
    letter-spacing: 1px;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    /* Ensures text aligns properly */
}

.fixed-button .icofont-google-map {
    font-size: 24px;
    margin-bottom: 10px;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
}

/* Modal Adjustments */


.modal-content {
    border-radius: 10px;
    margin-bottom: 10px;
}

.categories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
}

.category-item {
    position: relative;
    cursor: pointer;
    /* Additional styles for your category item */
}

.grayscale {
    filter: grayscale(100%);
    pointer-events: none;
    /* Prevent clicks on disabled categories */
    opacity: 0.5;
    /* Optional: make it visually clear that it's disabled */
}

.category-title {
    /* Style for category title */
    text-align: center;
}

.navbar {
    padding: 15px;
}

.navbar-brand img {
    height: 50px;
}

.header-section {
    text-align: center;
}

.category-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    color: white;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    position: relative;
}

.category-box:hover {
    transform: scale(1.05);
}

.row {
    margin-bottom: 15px;
}

.homeBanners {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

.category-label {
    position: absolute;
    z-index: 2;
    font-size: 1.8rem;
    font-weight: bold;
    max-width: 210px;
}

.category-label-1 {
    top: 30px
}

.category-label-2 {
    writing-mode: vertical-lr;
    text-orientation: upright;
    text-shadow: 1px 0px #fff;
    right: 50px;
}

.category-label-3 {
    bottom: 25%;
}

.category-label-3::before {
    content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAABU0lEQVR4nO2bQWrDMBQFH7lLcqq4tyihgYCXvVO2OUbaq0wJDa4Wrbrwl4TkN+CtJQ/2gD+2ZOIBDsAncXwAe/UCcCaeN/UCMBcQMKtTAXPr81QHC8B3AH4EFtwANW5JdXADcANwAxbcADVuSXVwA3ADcAMW3AA1bkl16K0BfM/wXoFT0HEtIOAauL/HtR7ShR5Dx1JECYjmni5UkuMKAVPJjekPAe+BxxHYrRCwe54jck95ARocC0hQ1sqgWECCslYGxQISlLUyKBaQoKyVQbGABGWtDIoFJChrZVAsIEG/WQmcupye7/NrX4en4D39KyCaaYWAFwqiZKHNj8T2wCVw6nIrMBO8Be7vUvTDS3obi0djAfgOmP0I/OAGqHFLqoMbgBuAG7DgBqhxS6qDG4AbgBuw4AaocUuqgxvA5n+cPLPxX2cPj+/wAi/+3tXP0+qILwrs6eJGVW4aAAAAAElFTkSuQmCC");
}

.category-label-11::before {
    content: url("data:image/png;base64,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");
}

.category-label-3-img {
    border: 3px solid #fff;
    padding: 8px;
    border-radius: 100%;
}

.category-label-4 {
    text-shadow: 1px 0px;
}

.category-label-5 {
    text-align: left;
    bottom: 20px;
    left: 15px;
    color: #606060;
}

.category-label-6 {
    color: #958961;
    text-shadow: 1px 0px;
}

.category-label-7 {
    color: #A27C65;
    top: 20px;
}

.category-label-8 {
    writing-mode: vertical-lr;
    text-orientation: upright;
    right: 30px;
    left: 0px;
    color: crimson;
}

.category-label-9 {
    text-shadow: 1px 0px;
    font-size: 3rem;
}

.category-label-10 {
    font-size: 1.4rem;
    text-align: right;
    right: 10px;
    color: white;
}

.category-label-11 {
    color: #739198;
    text-shadow: 1px 0px;
}

.category-label-21 {
    display: none;
}

.category-label-11-img {
    top: 30px;
    position: absolute;
}

.category-label-12 {
    color: #7F7F7F;
    text-shadow: 1px 0px;
    font-size: 3rem;
    top: 45px;
}

.category-label-13 {
    left: 20px;
    top: 60px;
    text-align: left;
    font-size: 3rem;
    text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff, 0 -2px 0 #fff, 0 2px 0 #fff, -2px 0 0 #fff, 2px 0 0 #fff;
    letter-spacing: .3rem;
    font-size: 3rem;
    color: #d4b090;
}

.category-label-13-hotel {
    text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff, 0px -2px 0 #fff, 0px 2px 0 #fff, -2px 0px 0 #fff, 2px 0px 0 #fff;
    letter-spacing: .3rem;
    font-size: 3rem;
    color: #D4B090;
}

.category-label-14 {
    color: #777;
    text-shadow: 1px 0px;
}

.category-label-15 {
    text-shadow: 1px 0px;
}

.category-label-16 {
    bottom: 15px;
    text-shadow: 1px 0;
    color: #f7ed97;
    background: #e39b12;
    padding: 0px 20px 0px 20px;
    max-width: fit-content;
    border-radius: 5px;
}

.category-label-17 {
    color: #5C6167;
    text-align: left;
    left: 35px;
    font-size: 2.2rem;
    text-shadow: 1px 0px;
}

.category-label-18 {
    color: #606060;
}

.category-label-24 {
    color: white;
    text-shadow: 1px 0px;
    font-size: 2rem;
}

.homeNumberOffers {
    font-size: 6.5rem;
    line-height: 6rem;
    color: #8FBDE9;
    text-shadow: 4px 0 #8FBDE9;
}

.homeOfferText {
    color: #175576;
    font-size: 2.5rem;
    line-height: 2.2rem;

}

.homeOffersubText {
    letter-spacing: 1px;
}

.grid-container {
    display: grid;
    /* grid-template-columns: repeat(4, 1fr); */
    /* grid-auto-rows: 150px; */
    gap: 25px;
    grid-auto-flow: dense;
}

.grid-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.item1 {
    grid-column: span 1;
    grid-row: span 2;
}

.item2 {
    grid-column: span 1;
    grid-row: span 3;
}

.item3 {
    grid-column: span 1;
    grid-row: span 2;
}

.item4 {
    grid-column: span 1;
    grid-row: span 1;
}

.item5 {
    grid-column: span 1;
    grid-row: span 1;
}

.item6 {
    grid-column: span 1;
    grid-row: span 2;
}

.item7 {
    grid-column: span 1;
    grid-row: span 2;
}

.item8 {
    grid-column: span 1;
    grid-row: span 2;
}

.item9 {
    grid-column: span 1;
    grid-row: span 1;
}

.item10 {
    grid-column: span 1;
    grid-row: span 1;
}

.item11 {
    grid-column: span 1;
    grid-row: span 2;
}

.item12 {
    grid-column: span 2;
    grid-row: span 2;
}

.item13 {
    grid-column: span 1;
    grid-row: span 1;
}

.item14 {
    grid-column: span 1;
    grid-row: span 2;
}

.item15 {
    grid-column: span 1;
    grid-row: span 1;
}

.item16 {
    grid-column: span 1;
    grid-row: span 2;
}

.item17 {
    grid-column: span 1;
    grid-row: span 2;
}

.item18 {
    grid-column: span 1;
    grid-row: span 1;
}

.item18 {
    grid-column: span 1;
    grid-row: span 1;
}

.item19 {
    grid-column: span 1;
    grid-row: span 2;
}

.item20 {
    grid-column: span 2;
    grid-row: span 2;
}

.item21 {
    grid-column: span 2;
    grid-row: span 2;
}

.item22 {
    grid-column: span 1;
    grid-row: span 1;
}

.item23 {
    grid-column: span 1;
    grid-row: span 1;
}

.item24 {
    grid-column: span 2;
    grid-row: span 2;
}

.item25 {
    grid-column: span 1;
    grid-row: span 1;
}

.item26 {
    grid-column: span 1;
    grid-row: span 2;
}

.item27 {
    grid-column: span 1;
    grid-row: span 1;
}

.item28 {
    grid-column: span 2;
    grid-row: span 2;
}

.item29 {
    grid-column: span 2;
    grid-row: span 2;
}

.item30 {
    grid-column: span 1;
    grid-row: span 1;
}

.item100 {
    grid-column: span 2;
    grid-row: span 1;
}

.profSection {
    background-image: url("../assets/images/home/second-banner-rot.png");
    background-position: bottom;
    background-size: cover;
    background-repeat: no-repeat;
}

.sectionBnrImg {
    width: 55%;
}

.myBtnHome {
    border-radius: 99px;
    background: #2D9CE0;
    font-size: x-large;
    padding: 2px 20px;
    font-weight: bold;
    color: #fff;
    transition: 1s;
}

.myBtnHome:hover {
    background: #2D9CE0;
    color: #fff;
    transform: scale(1.1);
    transition: 1s;
}

.mapMobBtn {
    /* display: none; */
    background: #175576;
    color: #fff;
    border: 0px;
    border-radius: 99px;
    padding: 1px 5px;
}
.btn-sorting{
    padding: 1px 5px;
}

.search-results {
    background: #fff;
    box-shadow: inset 0px 0px 10px 0px #dedede;
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 38px;
    top: 0;
}

.card {
    z-index: 99999;
    background: transparent;
}

.card-body {
    border-bottom: 1px solid #dedede;
}

.card-link {
    display: block;
    text-decoration: none;
    color: inherit;
    /* Prevent RouterLink from changing the text color */
    z-index: 99999;
}

.card-link:hover {
    text-decoration: none;
}

.search-input {
    background: #fff;
    border-width: 0px 0px 0px 0px;
    border-color: #175576;
    border-style: solid;
    color: #175576;
    /* box-shadow: inset 0px 0px 10px 0px #dedede; */
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    text-align: center;
}

.form-control:focus,
.form-select:focus {
    box-shadow: 0px 0px !important;
}

.searchDiv {
    position: relative;
    /* Ensures absolute positioning is relative to this */
    width: 100%;
    display: flex;
    align-items: center;
}

.shortcutBtn {
    display: none;
}

.searchSection {
    border-width: 0px 1px 1px 0px;
    border-color: #175576;
    border-style: solid;
    border-radius: 99px;
    border-bottom-left-radius: 0px;
}

.categoryNameSection {
    border-width: 0px 0px 1px 0px;
    border-color: #175576;
    border-style: solid;
}

@media only screen and (max-width: 1199px) {
    .homeNumberOffers {
        font-size: 4rem;
        line-height: 3rem;
    }

    .homeOffersubText {
        font-size: 1.5rem;
    }

    .category-label {
        font-size: 1.1rem;
        font-weight: bold;
        max-width: 150px;
        white-space: normal;
    }

    .item1 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item2 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item3 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item4 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item5 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item6 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item7 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item8 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item9 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item10 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item11 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item12 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item13 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item14 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item15 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item16 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item17 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item18 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item19 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item20 {
        grid-column: span 4;
        grid-row: span 2;
    }

    .item21 {
        grid-column: span 4;
        grid-row: span 2;
    }

    .item22 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item23 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item24 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item25 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item26 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item27 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item28 {
        grid-column: span 2;
        grid-row: span 2;
    }

    .item29 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .item30 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item31 {
        grid-column: span 2;
        grid-row: span 1;
    }

    .item100 {
        grid-column: span 4;
        grid-row: span 1;
    }

    .grid-container {
        gap: 10px;
    }

    .category-label-2 {
        right: 25px;
        font-size: 13px !important;
        top: 0px;
    }

    .category-label-3-img {
        border: 2px solid #fff;
        padding: 7px;
        width: 50px;
        top: 25px;
        position: absolute;
    }

    .category-label-18 {
        top: 40px;
    }

    /* .category-label-11-img{
            width: 50px;
            top: 10px;
        } */
    .category-label-11 {
        bottom: 10px;
    }

    .category-label-11::before {
        transform: scale(0.6) !important;
        display: flex;
        margin-bottom: -15px;
        margin-right: -50px;
    }

    .category-label-13-hotel {
        font-size: 2rem;
    }

    .mob-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }

    .categoryNameSection {
        display: none;
    }

    .flex-column-mobile {
        display: flex;
        flex-direction: column;
    }

    .fs-4 {
        font-size: 1rem !important;
    }

    .fs-5 {
        font-size: 1.1rem !important;
    }

    .fixed-button .icofont-google-map {
        font-size: 18px;
        right: 1px;
        position: relative;
    }

    .myBtnHome {
        font-size: 14px;
        padding: 2px 15px;
    }

    .homeOfferText {
        font-size: 1.3rem;
        line-height: 1.6rem;
    }

    .homeOffersubText {
        font-size: 1.1rem !important;
    }

    .homeNumberOffers {
        font-size: 3rem;
        line-height: 2.5rem;
        text-shadow: 2px 0 #8FBDE9;
    }

    .sectionBnrImg {
        width: 180px;
    }

    .mapMobBtn {
        display: unset;
        /* background: #175576;
        font-size: 16px;
        border: 0px;
        color: #fff;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center; */
    }

    .shortcutBtn {
        position: fixed;
        top: 75%;
        right: 0%;
        background: #175576;
        color: #fff;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        padding: 3.5px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        width: 26px;
    }

    .justify-content-center-mobile {
        justify-content: center !important;
        display: flex;
    }

    .w-sm-100 {
        width: 100% !important;
    }

    .searchSection {
        border-width: 0px 0px 1px 0px;
        border-radius: 0px;
        border-bottom-left-radius: 0px;
    }

    .categoryNameSection {
        border-width: 0px 0px 0px 0px;
        display: none;
    }

    .header-section img {
        width: 90px;
    }

    .shortcutBtnModal {
        background: #175576;
        color: #fff;
        border: 0px;
        justify-content: center;
        display: flex;
        align-items: center;
        border-radius: 99px;
        font-size: 1rem;
        padding: 2px 15px;
        margin: 0 auto;
    }

    .search-results {
        top: 0;
    }

    .modal {
        z-index: 9999;
    }

    .fixed-button {
        top: 61%;
        width: 28px;
        padding: 6px;
    }
    .fixed-button-faq{
        top: 46%;
        width: 28px;
        padding: 6px;
    }
}
</style>
